import styled from "styled-components";

export const Container = styled.div`
  font-family: "Poppins", sans-serif;
  width: 90%;
  height: auto;
  border: none;
  z-index: 99;
  position: absolute;
  .title-modal {
    font-family: "Poppins", sans-serif;
    color: #646464;
  }
  .button-modal {
    //  color: "#fff",
    //   background: "#ff9900",
    //   border: "none",
    //   padding: "0.6rem",
    //   textAlign: "center",
    //   justifyContent: "center",
    //   transition: "all 0.5s",
    //   alignItems: "center",
    //   margin: "auto",
    //   width: "38%",
    //   borderRadius: "2rem",
    // }}
  }
`;
